
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0072C8","fill-rule":"evenodd","d":"M8.5 7.5h3.079a1 1 0 011 1H8.5v3.998h-1V8.5H4.421a1 1 0 01-1-1H7.5v-4h1v4z"}})])
          )
        }
      }
    